"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames2 = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Card = function Card(_ref) {
  var _classnames;
  var lineColour = _ref.lineColour,
    title = _ref.title,
    details = _ref.details,
    extraDetails = _ref.extraDetails,
    detailsElement = _ref.detailsElement,
    className = _ref.className,
    children = _ref.children,
    lineThickness = _ref.lineThickness,
    lineBorderRadius = _ref.lineBorderRadius,
    titleIcon = _ref.titleIcon;
  var cardClassNames = (0, _classnames2.default)((_classnames = {
    Card: true
  }, _defineProperty(_classnames, "Card--".concat(lineColour), !!lineColour), _defineProperty(_classnames, "Card--line-".concat(lineThickness), !!lineThickness), _defineProperty(_classnames, "Card--line-border-radius-".concat(lineBorderRadius), !!lineBorderRadius), _classnames), className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: cardClassNames
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "Card_cardTitle"
  }, titleIcon && /*#__PURE__*/_react.default.createElement("img", {
    className: "Card_cardIcon",
    src: titleIcon,
    alt: "title icon"
  }), /*#__PURE__*/_react.default.createElement("h1", {
    title: title,
    className: "Card_cardName"
  }, title)), detailsElement ? /*#__PURE__*/_react.default.createElement("div", {
    className: "Card_detailsElement"
  }, detailsElement) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", {
    title: details,
    className: "Card_details"
  }, details), /*#__PURE__*/_react.default.createElement("p", {
    title: extraDetails,
    className: "Card_extraDetails"
  }, extraDetails)), children && /*#__PURE__*/_react.default.createElement("div", {
    className: "Card_children"
  }, children));
};
var _default = Card;
exports.default = _default;